import React, { Fragment } from 'react'
import styles from '../FormStyles.module.scss'
import { compose } from 'redux'
import withFormResponseHandler from '../withFormResponseHandler'
import classnames from 'classnames'
import {
  makeForm,
  TextareaFormField,
  SelectDropdownFormField,
  RadioFormField,
  CheckboxFormField,
  BaseComponent,
  NumberFormField
} from 'belle-js'
import {
  showAdditionalDetailsForm,
  employeesEligible,
  planServiceRequirement,
  contributionFormula,
  allocationFormula,
  planAgeRequirement,
  topHeavyMinimumAllocation,
  conpensationElections,
  planYear,
  simpleIraServiceRequirement,
  simpleIraEmployeesEligible,
  simpleIraElectionPeriods,
  sepYesOrNo,
  serviceRequirement401k,
  SERVICE_REQUIREMENT_VALUES,
} from 'utils/financialAccountAdditionalDetailsOptions'
import {
  yesOrNo
} from 'utils/fieldOptions'
import {
  showSection,
  CONTRIBUTION_FORMULA,
  ALLOCATION_FORMULA,
  MINIMUM_ALLOCATION,
  PLAN_YEAR,
  SIMPLE_ELIGIBILITY,
  EMPLOYER_CONTRIBUTIONS,
} from 'utils/financialAccountAdditionalDetails'
import {
  percentageValidation,
  currencyValidation
} from 'utils/fieldValidations'
import { SCHWAB_IRA } from 'utils/financialAccountTypes'
import AdditionalDetailsFormHeader from './AdditionalDetailsFormHeader'
import AdditionalDetailsFormSectionWrapper from './AdditionalDetailsFormSectionWrapper'
import AdditionalDetailsFormSection from './AdditionalDetailsFormSection'
import IntegratedFormula from './IntegratedFormula/IntegratedFormula'
import ContributionsFormula from './ContributionsFormula/ContributionsFormula'
import MinimumAllocationDetails from './MinimumAllocationDetails/MinimumAllocationDetails'
import PlanYearDetails from './PlanYearDetails/PlanYearDetails'
import LimitedEligibilty from './LimitedEligibilty/LimitedEligibilty'
import EmployerContributions from './EmployerContributions/EmployerContributions'

class AdditionalDetailsForm extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = {
      showFormulaValues: false,
      showIntegratedFormula: false,
      showMinimumAllocationDetails: false,
      showPlanYearDetails: false,
      showForm: this.determineShowFormState(props),
      showSimpleElegibiltyDetails: false,
      showEmployerContributionsDetails: false,
      subType: ''
    }
    this.radioInput = React.createRef()
    this.bind(
      'handleRadioChange',
      'handleToggleForm',
      'isSepIra',
      'isIndividual401k',
      'renderAgeRequirementSection',
    )
  }

  componentDidMount () {
    this.updateDropdownStates()
  }

  componentWillReceiveProps (nextProps) {
    const { subType } =  this.state
    if (nextProps.data.subType !==  subType) {
      this.updateDropdownStates()
    }
  }

  updateDropdownStates () {
    const {
      data: {
        sepContributionFormula,
        sepAllocationFormula,
        sepTopHeavyMinimumAllocation,
        sepPlanYearElections,
        simpleCatchUpContributionsPermitted,
        simpleEligibilityServiceRequirement,
        simpleApproveDefaultAddtlDetails,
        sepApproveDefaultAdditionalDetails,
        subType,
        eligibilityServiceRequirement,
      }
    } = this.props

    const isSepIra = this.isSepIra(subType)

    this.handleToggleForm(
      isSepIra ? sepApproveDefaultAdditionalDetails : simpleApproveDefaultAddtlDetails
    )

    this.handleRadioChange(sepContributionFormula, 'sepContributionFormula')
    this.handleRadioChange(sepAllocationFormula, 'sepAllocationFormula')
    this.handleRadioChange(sepTopHeavyMinimumAllocation, 'sepTopHeavyMinimumAllocation')
    this.handleRadioChange(sepPlanYearElections, 'sepPlanYearElections')
    this.handleRadioChange(simpleCatchUpContributionsPermitted, 'simpleCatchUpContributionsPermitted')
    this.handleRadioChange(simpleEligibilityServiceRequirement, 'simpleEligibilityServiceRequirement')
    this.handleRadioChange(eligibilityServiceRequirement, 'eligibilityServiceRequirement')
    this.radioInput.current.setValue(
      isSepIra ? sepApproveDefaultAdditionalDetails : simpleApproveDefaultAddtlDetails
    )
    this.setState({ subType })
  }

  handleRadioChange (value, inputName) {
    const {
      CONTRIBUTION_FORMULA_FIELD_VALUE,
      SHOW_CONTRIBUTION_FORMULA_FIELD,
      HIDE_CONTRIBUTION_FORMULA_FIELD,
      CONTRIBUTION_FORMULA_FIELD_NAME
    } = CONTRIBUTION_FORMULA

    const {
      ALLOCATION_FORMULA_FIELD_VALUE,
      SHOW_ALLOCATION_FORMULA_FIELD,
      HIDE_ALLOCATION_FORMULA_FIELD,
      ALLOCATION_FORMULA_FIELD_NAME
    } = ALLOCATION_FORMULA

    const {
      MINIMUM_ALLOCATION_FIELD_NAME,
      MINIMUM_ALLOCATION_FIELD_VALUE,
      SHOW_MINIMUM_ALLOCATION_FIELD,
      HIDE_MINIMUM_ALLOCATION_FIELD
    } = MINIMUM_ALLOCATION

    const {
      PLAN_YEAR_FIELD_NAME,
      PLAN_YEAR_FIELD_VALUE,
      SHOW_PLAN_YEAR_FIELD,
      HIDE_PLAN_YEAR_FIELD
    } = PLAN_YEAR

    const {
      SIMPLE_ELIGIBILITY_FIELD_NAME,
      SIMPLE_ELIGIBILITY_FIELD_VALUE,
      SHOW_SIMPLE_ELIGIBILITY_FIELD,
      HIDE_SIMPLE_ELIGIBILITY_FIELD,
    } = SIMPLE_ELIGIBILITY

    const {
      EMPLOYER_CONTRIBUTIONS_FIELD_NAME,
      EMPLOYER_CONTRIBUTIONS_FIELD_VALUE,
      SHOW_EMPLOYER_CONTRIBUTIONS_FIELD,
      HIDE_EMPLOYER_CONTRIBUTIONS_FIELD
    } = EMPLOYER_CONTRIBUTIONS

    let result = {}

    switch (inputName) {
      case CONTRIBUTION_FORMULA_FIELD_NAME:
        if (value === CONTRIBUTION_FORMULA_FIELD_VALUE) {
          result = SHOW_CONTRIBUTION_FORMULA_FIELD
        } else {
          result = HIDE_CONTRIBUTION_FORMULA_FIELD
        }
        break
      case ALLOCATION_FORMULA_FIELD_NAME:
        if (value === ALLOCATION_FORMULA_FIELD_VALUE) {
          result = SHOW_ALLOCATION_FORMULA_FIELD
        } else {
          result = HIDE_ALLOCATION_FORMULA_FIELD
        }
        break
      case MINIMUM_ALLOCATION_FIELD_NAME:
        if (value === MINIMUM_ALLOCATION_FIELD_VALUE) {
          result = SHOW_MINIMUM_ALLOCATION_FIELD
        } else {
          result = HIDE_MINIMUM_ALLOCATION_FIELD
        }
        break
      case PLAN_YEAR_FIELD_NAME:
        if (value === PLAN_YEAR_FIELD_VALUE) {
          result = SHOW_PLAN_YEAR_FIELD
        } else {
          result = HIDE_PLAN_YEAR_FIELD
        }
        break
      case SIMPLE_ELIGIBILITY_FIELD_NAME:
        if (value === SIMPLE_ELIGIBILITY_FIELD_VALUE) {
          result = SHOW_SIMPLE_ELIGIBILITY_FIELD
        } else {
          result = HIDE_SIMPLE_ELIGIBILITY_FIELD
        }
        break
      case EMPLOYER_CONTRIBUTIONS_FIELD_NAME:
        if (value === EMPLOYER_CONTRIBUTIONS_FIELD_VALUE) {
          result = SHOW_EMPLOYER_CONTRIBUTIONS_FIELD
        } else {
          result = HIDE_EMPLOYER_CONTRIBUTIONS_FIELD
        }
        break
      default:
    }
    this.setState(result)
  }

  determineShowFormState (props) {
    const { data } = props
    if (data &&
      (data.sepApproveDefaultAdditionalDetails === 'False' ||
      data.simpleApproveDefaultAdditionalDetails === 'False')
    ) {
      return true
    }
    return false
  }

  handleToggleForm (val) {
    if (val === 'False') {
      this.setState({ showForm: true })
    } else {
      this.setState({ showForm: false })
    }
  }

  isSepIra (subType) {
    return (subType === SCHWAB_IRA.ACCOUNT_TYPES.SEP_IRA)
  }

  isIndividual401k (subType) {
    return (subType === SCHWAB_IRA.ACCOUNT_TYPES.INDIVIDUAL_401K)
  }

  renderAgeRequirementSection (data, title) {
    return (
      <AdditionalDetailsFormSection
        title={title}
        showBottomLine={false}
        description="An Employee will be eligible to become a Participant in the
        Plan after attaining the following age:">

        <div className={styles.inputWrapper}>
          <SelectDropdownFormField
            name="sepPlanAgeRequirement"
            className="dropdown"
            options={planAgeRequirement}
            required={false}
            value={data.sepPlanAgeRequirement || ''}
            testId="sepPlanAgeRequirement" />
        </div>
      </AdditionalDetailsFormSection>
    )
  }

  renderEligibilitySection (subType) {
    const { showSimpleElegibiltyDetails } = this.state
    const {
      data,
      formData: {
        eligibilityServiceRequirement = SERVICE_REQUIREMENT_VALUES.NO_ELIGIBILITY,
        eligibilityServiceRequirementYears,
        eligibilityServiceRequirementMonths,
      },
    } = this.props
    const radioStyles = classnames(styles.formToggle, styles.detailsRadio)

    const description = `
      An Employee will be eligible to become a Participant in
      the Plan after having performed
      service for the Employer during at least
    `

    const isSepIra = this.isSepIra(subType)
    const isIndividual401k = this.isIndividual401k(subType)
    const showServiceRequirement = isSepIra || isIndividual401k
    const choseServiceYears = 
      eligibilityServiceRequirement === SERVICE_REQUIREMENT_VALUES.ELIGIBILITY_YEARS
    const choseServiceMonths = 
      eligibilityServiceRequirement === SERVICE_REQUIREMENT_VALUES.CONSECUTIVE_MONTHS

    return (
      <AdditionalDetailsFormSectionWrapper
        label="Eligibility & Participation Requirements" >

        <AdditionalDetailsFormSection
          title="Service Requirement"
          description={showServiceRequirement ? description : ''}>

          {showServiceRequirement &&
            <Fragment>
              <div className={styles.inputWrapper}>
                <SelectDropdownFormField
                  name="sepPlanServiceRequirement"
                  className="dropdown"
                  options={planServiceRequirement}
                  value={data.sepPlanServiceRequirement || ''}
                  required={true}
                  testId="sepPlanServiceRequirement" />
              </div>
              <div className={styles.text}>
                of the immediately preceding five Plan Years.
              </div>
              <div className={styles.text}>
                For purposes of determining whether an Employee has met the service requirement,
                an Employee shall be given credit for service with
                the following predecessor employer(s).
              </div>
              <div className={styles.inputWrapper}>
                <TextareaFormField
                  name="sepPlanServiceRequirementDetails"
                  rows="10"
                  cols="10"
                  className={styles.detailsTextarea}
                  placeholder="Complete if applicable"
                  value={data.sepPlanServiceRequirementDetails || ''}
                  testId="sepPlanServiceRequirementdetails" />
              </div>
            </Fragment>
          }
          {!isSepIra &&
            <div className={styles.radioListWrapper}>
              <RadioFormField
                name="simpleEligibilityServiceRequirement"
                options={simpleIraServiceRequirement}
                value={data.simpleEligibilityServiceRequirement}
                required={false}
                horizontal={false}
                testId="simpleEligibilityServiceRequirement"
                onChange={value => this.handleRadioChange(value, 'simpleEligibilityServiceRequirement')} />
            </div>
          }
          {!isSepIra && showSimpleElegibiltyDetails && <LimitedEligibilty data={data} />}
        </AdditionalDetailsFormSection>

        {isIndividual401k &&
          <AdditionalDetailsFormSection title="Eligibility" >
            <div className={styles.text} >Complete Sections A and B below.</div>
            <AdditionalDetailsFormSection title="part a: Eligibility Service Requirement" >
              <div className={styles.text} >
                Please select one and complete the numeric field of applicable.
              </div>
              <div className={styles.checkboxListWrapper}>
                <RadioFormField
                  name="eligibilityServiceRequirement"
                  horizontal={false}
                  options={serviceRequirement401k}
                  required={true}
                  testId="eligibilityServiceRequirement"
                  value={eligibilityServiceRequirement}
                  onChange={value => this.handleRadioChange(value, 'eligibilityServiceRequirement')} />
              </div>
              {
                choseServiceYears &&
                <NumberFormField
                  label="Consecutive years of service"
                  name="eligibilityServiceRequirementYears"
                  placeholder="0"
                  required={true}
                  value={eligibilityServiceRequirementYears}
                  testId="eligibilityServiceRequirementYears"
                  allowDecimal={false}
                  max={1}
                  min={0}
                  className={styles.EligibilityFieldSection} />
              }
              {
                choseServiceMonths &&
                <NumberFormField
                  label="Consecutive months of service"
                  name="eligibilityServiceRequirementMonths"
                  placeholder="1"
                  required={true}
                  value={eligibilityServiceRequirementMonths}
                  testId="eligibilityServiceRequirementMonths"
                  allowDecimal={false}
                  max={12}
                  min={1}
                  className={styles.EligibilityFieldSection} />
              }
            </AdditionalDetailsFormSection>
            { this.renderAgeRequirementSection(data, 'part B: age Requirement') }
          </AdditionalDetailsFormSection>
        }

        {isSepIra &&
          <Fragment>
            { this.renderAgeRequirementSection(data) }

            <AdditionalDetailsFormSection
              title="Employees Employed as of Effective Date"
              description="Will an Employee employed as of the Effective Date of this Plan
              who has not otherwise met the age and service
              requirements of the Plan be considered to have
              met those requirements as of the Effective Date?">

              <div className={styles.radioWrapper}>
                <RadioFormField
                  name="sepEmployedAsOfEffectiveDate"
                  horizontal={false}
                  options={yesOrNo}
                  required={false}
                  testId="sepEmployedAsOfEffectiveDate"
                  value={data.sepEmployedAsOfEffectiveDate || ''} />
              </div>
            </AdditionalDetailsFormSection>
            <AdditionalDetailsFormSection
              title="Class of Employees Eligible to Participate"
              description="All Employees shall be eligible to become Participants in the Plan,
              except the following. Select any that apply."
              showBottomLine={false}>

              <div className={styles.checkboxListWrapper}>
                {employeesEligible.map(option =>
                  (<CheckboxFormField
                    key={option.name}
                    name={option.name}
                    className={radioStyles}
                    label={option.label}
                    value={data[option.name] || ''}
                    testId={option.name} />)
                )}
              </div>
            </AdditionalDetailsFormSection>
          </Fragment>
        }

        {!isSepIra &&
          <Fragment>
            <AdditionalDetailsFormSection
              title="Class of Employees Eligible to Participate"
              description="All Employees shall be eligible to become Participants in the Plan,
            except the following. Select any that apply." >

              <div className={styles.checkboxListWrapper}>
                {simpleIraEmployeesEligible.map(option =>
                  (<CheckboxFormField
                    key={option.name}
                    name={option.name}
                    className={radioStyles}
                    label={option.label}
                    testId={option.name}
                    value={data[option.name] || ''} />)
                )}
              </div>
            </AdditionalDetailsFormSection>

            <AdditionalDetailsFormSection
              title="Election Periods"
              description="In addition to the 60-day Election Period described in Section
            3.04 of the Plan, a Participant may make or modify a Salary Reduction
            Agreement during the following Election Periods:"
              showBottomLine={false}>

              <div className={styles.inputWrapper}>
                <SelectDropdownFormField
                  name="simpleModificationElectionPeriods"
                  className="dropdown"
                  options={simpleIraElectionPeriods}
                  value={data.simpleModificationElectionPeriods}
                  testId="simpleModificationElectionPeriods" />
              </div>
            </AdditionalDetailsFormSection>

          </Fragment>
        }
      </AdditionalDetailsFormSectionWrapper>
    )
  }

  renderContributionsSection (subType) {
    const { data } = this.props

    const {
      showFormulaValues,
      showIntegratedFormula,
      showMinimumAllocationDetails,
      showEmployerContributionsDetails
    } = this.state

    const isSepIra = this.isSepIra(subType)

    return (
      <AdditionalDetailsFormSectionWrapper
        label="Contributions & Allocations"
        showBottomLine={false}>
        {isSepIra &&
        <Fragment>
          <AdditionalDetailsFormSection
            title="Contribution Formula">
            <div className={styles.radioListWrapper}>
              <RadioFormField
                name="sepContributionFormula"
                horizontal={false}
                options={contributionFormula}
                required={false}
                value={data.sepContributionFormula || ''}
                onChange={value => this.handleRadioChange(value, 'sepContributionFormula')}
                testId="sepContributionFormula" />
            </div>
            {showFormulaValues && <ContributionsFormula data={data} />}
          </AdditionalDetailsFormSection>

          <AdditionalDetailsFormSection
            title="Allocation Formula">
            <div className={styles.radioListWrapper}>
              <RadioFormField
                name="sepAllocationFormula"
                horizontal={false}
                options={allocationFormula}
                required={false}
                value={data.sepAllocationFormula || ''}
                onChange={value => this.handleRadioChange(value, 'sepAllocationFormula')}
                testId="sepAllocationFormula" />
            </div>
            {showIntegratedFormula && <IntegratedFormula data={data} />}
          </AdditionalDetailsFormSection>

          <AdditionalDetailsFormSection
            title="Top-Heavy Minimum Allocation"
            description="For any Plan Year with respect to which this Plan is a Top-Heavy Plan,
            any minimum allocation required pursuant to Section 4.02 of the Plan shall be made:"
            showBottomLine={true}>
            <div className={styles.radioListWrapper}>
              <RadioFormField
                name="sepTopHeavyMinimumAllocation"
                horizontal={false}
                options={topHeavyMinimumAllocation}
                required={false}
                value={data.sepTopHeavyMinimumAllocation || ''}
                onChange={value => this.handleRadioChange(value, 'sepTopHeavyMinimumAllocation')}
                testId="sepTopHeavyMinimumAllocation" />
            </div>
            {showMinimumAllocationDetails && <MinimumAllocationDetails data={data} />}
          </AdditionalDetailsFormSection>
        </Fragment>
        }
        {!isSepIra &&
          <Fragment>
            <AdditionalDetailsFormSection
              title="Catch-Up Contributions"
              description="Will Catch-Up Contributions, as described in Section
              4.01 of the Plan, be permitted under this Plan?"
              showBottomLine={showEmployerContributionsDetails}>
              <div className={styles.radioWrapperYesNo}>
                <RadioFormField
                  name="simpleCatchUpContributionsPermitted"
                  horizontal={false}
                  options={sepYesOrNo.yesDefault}
                  required={false}
                  onChange={value => this.handleRadioChange(value, 'simpleCatchUpContributionsPermitted')}
                  testId="simpleCatchUpContributionsPermitted"
                  value={data.simpleCatchUpContributionsPermitted || 'Yes'} />
              </div>
            </AdditionalDetailsFormSection>
            {showEmployerContributionsDetails && <EmployerContributions data={data} />}
          </Fragment>
        }
      </AdditionalDetailsFormSectionWrapper>
    )
  }

  renderCompensationSection () {
    const { data } = this.props
    const {
      showPlanYearDetails
    } = this.state

    return (
      <AdditionalDetailsFormSectionWrapper
        label="Compensation & Plan Year Elections">

        <AdditionalDetailsFormSection
          title="Compensation"
          description="For purposes of Employer Contributions, Compensation
          will mean all of each Participant’s:">
          <div className={styles.radioListWrapper}>
            <RadioFormField
              name="sepCompensationElections"
              horizontal={false}
              options={conpensationElections}
              required={false}
              value={data.sepCompensationElections || ''}
              testId="sepCompensationElections" />
          </div>
        </AdditionalDetailsFormSection>

        <AdditionalDetailsFormSection
          title="Plan Year"
          showBottomLine={false}>
          <div className={styles.radioListWrapper}>
            <RadioFormField
              name="sepPlanYearElections"
              horizontal={false}
              options={planYear}
              required={false}
              value={data.sepPlanYearElections || ''}
              onChange={value => this.handleRadioChange(value, 'sepPlanYearElections')}
              testId="sepPlanYearElections" />
          </div>
          {showPlanYearDetails && <PlanYearDetails data={data} />}
        </AdditionalDetailsFormSection>
      </AdditionalDetailsFormSectionWrapper>
    )
  }

  renderSalarySection () {
    const { data } = this.props
    const inputSeparatorstyles = classnames(styles.text, styles.inputSeparatorMargin)
    return (
      <AdditionalDetailsFormSectionWrapper
        label="Salary Deferral"
        isLastSection={true}
        showBottomLine={false}>

        <AdditionalDetailsFormSection
          title="Limits on Elective Deferrals"
          description="A Contributing Participant may elect under a salary reduction agreement
          to have his or her Compensation reduced by an amount not in excess of">
          <div className={styles.inputWrapper}>
            <NumberFormField
              format="currency"
              allowDecimal={true}
              name="sepElectiveDeferralDollar"
              className={styles.FormFieldInSection}
              placeholder="0"
              validations={currencyValidation.rules}
              validationErrors={currencyValidation.messages}
              value={data.sepElectiveDeferralDollar || ''}
              required={false}
              testId="sepElectiveDeferralDollar" />
          </div>
          <div className={inputSeparatorstyles}>
            or
          </div>
          <div className={styles.inputWrapper}>
            <NumberFormField
              format="percentage"
              allowDecimal={false}
              name="sepElectiveDeferralPercentage"
              className={styles.FormFieldInSection}
              placeholder="100"
              maxLength="3"
              validations={percentageValidation.rules}
              validationErrors={percentageValidation.messages}
              value={data.sepElectiveDeferralPercentage || ''}
              required={false}
              testId="sepElectiveDeferralPercentage" />
          </div>
          <div className={inputSeparatorstyles}>
            of Compensation.
          </div>
        </AdditionalDetailsFormSection>

        <AdditionalDetailsFormSection
          title="Separate Deferral Election for Bonuses"
          description="Instead of or in addition to making Elective Deferrals through payroll deduction,
        may a Contributing Participant make a separate deferral election
        to contribute to the Plan, as an Elective Deferral,
        part or all of a bonus rather than receive such bonus in cash?">
          <div className={styles.radioWrapperYesNo}>
            <RadioFormField
              name="sepAllowSeparateDeferral"
              horizontal={false}
              options={sepYesOrNo.noDefault}
              required={false}
              testId="sepAllowSeparateDeferral"
              value={data.sepAllowSeparateDeferral || ''} />
          </div>
        </AdditionalDetailsFormSection>

        <AdditionalDetailsFormSection
          title="Catch-Up Contributions"
          description="Will Catch-Up Contributions, as described in Section 7.01(B) of the Plan,
          be permitted under this Plan?"
          showBottomLine={false}>
          <div className={styles.radioWrapperYesNo}>
            <RadioFormField
              name="sepCatchUpContributionsPermitted"
              horizontal={false}
              options={sepYesOrNo.yesDefault}
              required={false}
              testId="sepCatchUpContributionsPermitted"
              value={data.sepCatchUpContributionsPermitted || ''} />
          </div>
        </AdditionalDetailsFormSection>
      </AdditionalDetailsFormSectionWrapper>
    )
  }

  renderFormHeader (showForm, subType) {
    const finalSubType = subType.replace('-', ' ')

    const title = `${finalSubType}s require additional settings. In order to save you time,
      we've filled in Schwab's default settings for ${finalSubType}s. You have the option
      to change any of the default settings that we've selected for you.`

    const description =  'Would you like to review the questions?'
    
    return (
      <AdditionalDetailsFormHeader
        showForm={showForm}
        title={title}
        description={description}>
        {this.renderShowFormRadio()}
      </AdditionalDetailsFormHeader>
    )
  }

  renderShowFormRadio () {
    const { data, subType } = this.props
    const isSepIra = this.isSepIra(subType)

    const value = isSepIra ? data.sepApproveDefaultAdditionalDetails :
      data.simpleApproveDefaultAddtlDetails

    const inputName = isSepIra ? 'sepApproveDefaultAdditionalDetails' :
      'simpleApproveDefaultAddtlDetails'

    this.determineShowFormState(this.props)

    return (
      <RadioFormField
        ref={this.radioInput}
        name={inputName}
        horizontal={false}
        options={showAdditionalDetailsForm}
        required={false}
        testId={inputName}
        onChange={this.handleToggleForm}
        value={value || ''} />
    )
  }

  render () {
    const {
      subType,
      formValid,
      onClick
    } = this.props

    const {
      showForm
    } = this.state

    const primaryButtonClasses = classnames(
      'button',
      'button--primary',
      styles.buttonMargin,
      styles.submitButton,
    )

    return (
      <div className={styles.form}>
        <div className={styles.AdditionalDetails}>

          {this.renderFormHeader(showForm, subType)}

          {showForm &&
            <Fragment>
              {showSection(subType, 'eligibility') &&
                this.renderEligibilitySection(subType)
              }

              {showSection(subType, 'contributions') &&
                this.renderContributionsSection(subType)
              }

              {showSection(subType, 'compensation') &&
                this.renderCompensationSection()
              }

              {showSection(subType, 'salary') &&
                this.renderSalarySection()
              }
            </Fragment>
          }
          {
            /* eslint-disable react/button-has-type */
            <button
              className={primaryButtonClasses}
              type={formValid ? 'submit' : 'button'}
              data-test-id="additionalDetails__saveAndContinue__cta"
              onClick={onClick}>
              Save and Continue
            </button>
          }
        </div>
      </div>
    )
  }

}
export default compose(
  makeForm,
  withFormResponseHandler,
)(AdditionalDetailsForm)



// WEBPACK FOOTER //
// ./src/components/Onboarding/AdditionalDetails/AdditionalDetailsForm.jsx